import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Image from 'gatsby-image';
import { push } from 'gatsby';

import { Block, Button } from '../common';

class CTA extends PureComponent {
  handleCTA = () => {
    push('/personalisation');
  };
  render() {
    const { buttonText, image, children } = this.props;
    return (
      <Block>
        <Block
          style={{
            position: 'relative',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {!!image && (
            <div
              style={{
                position: 'absolute',
                zIndex: 0,
                top: 0,
                right: 0,
                left: 0,
                bottom: 0,
              }}
            >
              <Image {...image} style={{ height: '100%' }} />
            </div>
          )}
          <div style={{ padding: 50, zIndex: 1 }}>
            {!!children && (
              <div style={{ color: 'white', marginBottom: 40 }}>{children}</div>
            )}
            <Button onClick={this.handleCTA}>{buttonText}</Button>
          </div>
        </Block>
      </Block>
    );
  }
}

CTA.defaultProps = {};

CTA.propTypes = {
  buttonText: PropTypes.string.isRequired,
};

export default CTA;
